<template>
  <div class="registerForm" v-show="isShow" @keydown.enter="handleSubmit">
    <div class="header">
      <div class="title">用户注册</div>
      <div class="close-btn" @click="gotoLogin">
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-arrow-left-circle"></use>
        </svg>
      </div>
    </div>
    <el-form class="user-layout-login" ref="form" :model="form" :rules="rules" >
      <el-form-item prop="account">
        <el-input :oninput="form.account=form.account.replace(/[^\d]/g,'')" type="text" autocomplete="off" maxLength="11" placeholder="请输入手机号" v-model.trim="form.account">
          <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" slot="prefix">
            <use xlink:href="#icon-shouji1"></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input autocomplete="off" :type="isShowPassword?'text':'password'" maxLength="12" placeholder="请输入密码" v-model.trim = "form.password">
          <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" slot="prefix">
            <use xlink:href="#icon-mima"></use>
          </svg>
          <svg class="show-password" width="1em" height="1em" fill="currentColor" aria-hidden="true" slot="suffix" @click="isShowPassword = !isShowPassword">
            <use :xlink:href="isShowPassword?'#icon-browse':'#icon-eye-close'"></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item prop="repassword">
        <el-input autocomplete="off" :type="isShowRePassword?'text':'password'" maxLength="12" placeholder="确认密码" v-model.trim = "form.repassword">
          <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" slot="prefix">
            <use xlink:href="#icon-mima"></use>
          </svg>
          <svg class="show-password" width="1em" height="1em" fill="currentColor" aria-hidden="true" slot="suffix" @click="isShowRePassword = !isShowRePassword">
            <use :xlink:href="isShowRePassword?'#icon-browse':'#icon-eye-close'"></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item prop="captcha" style="margin-bottom: 12px;">
        <el-col :span="14">
          <el-input type="text" autocomplete="off" maxLength="6" placeholder="请输入验证码" v-model.trim="form.captcha">
            <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" slot="prefix">
              <use xlink:href="#icon-yanzhengma"></use>
            </svg>
          </el-input>
        </el-col>
        <el-col :span="9" :offset="1" style="text-align: right;">
          <el-button class="getCaptcha" type="primary" :disabled="state.smsSendBtn" @click.stop.prevent="getCaptcha" v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"></el-button>
        </el-col>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px; text-align: left">
        <el-checkbox v-model = "form.isAngree">
          已阅读并同意
        </el-checkbox>
        <span class="user-rule-button" @click.stop="onClickRule">《用户协议》</span>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px;">
        <el-button  type="primary" htmlType="submit" class="login-button" :loading="state.loginBtn" :disabled="state.loginBtn" @click="handleSubmit">注册</el-button>
      </el-form-item>
      <!-- <div class="text-button">
        <span @click="gotoLogin">返回登录</span>
      </div> -->
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { validatePhone, validatePassword, validateCaptcha } from '@/utils/rules'
import { getSmsCaptcha } from '@/api/system'
import { register } from '@/api/login'
import md5 from 'md5'
import { setToken } from '@/utils/auth'
import {
  inviteMemberApi,
  detectTeam,
  switchTeam,
  teamListSelect
} from '@/api/teamManagement'
export default {
  name: 'RegisterForm',
  data () {
    return {
      isShow: false,
      capctchaCheck: false,
      loginBtn: false,
      isShowPassword: false,
      isShowRePassword: false,

      rules: {
        account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        repassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' },
          { validator: this.handlePasswordCheck, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCaptcha, trigger: 'blur' }
        ]
      },
      grant_type: 'password',
      form: {
        'account': '',
        'password': '',
        'captcha': '',
        'repassword': '',
        'isAngree': false
      },
      state: {
        time: 60,
        loginBtn: false,
        smsSendBtn: false,
        grant_type: 'password'
      }
    }
  },
  mounted () {

  },
  created () {

  },
  methods: {
    ...mapActions(['Login', 'Logout', 'GetInfo']),

    show (isShow) {
      this.clear()
      this.isShow = isShow
    },
    handlePasswordCheck (rule, value, callback) {
      const password = this.form.password
      if (value === undefined) {
        callback(new Error('请再次输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    async handleSubmit (e) {
      e.preventDefault()
      await this.$refs.form.validate()
      if (!this.form.isAngree) {
        this.$message.warning('请先同意用户协议')
        return
      }
      try {
        const { data } = await register({
          code: this.form.captcha.replace(/ /g, ''),
          password: md5(this.form.password),
          mobilePhone: this.form.account
        })
        const token = data.token_type + ' ' + data.access_token
        setToken(token)

        // 判断是否是通过邀请链接注册
        let { teamId, noncestr } = this.$route.query
        teamId = Number(teamId)
        if (noncestr) {
          // 通过邀请链接注册
          const { data } = await this.GetInfo()
          const userId = data.id
          const res = await detectTeam({ teamId, userId })
          if (res.data) {
            const res = await teamListSelect()
            await switchTeam({ teamId: res.data[0].id })

            this.$message.warning('你已加入该团队!')
            this.$router.push({ path: '/controlPlatform' })
          } else {
            await inviteMemberApi({ noncestr })
            const res = await teamListSelect()
            await switchTeam({ teamId: res.data[0].id })

            this.$message.success('加入团队成功!')
            this.$router.push({ path: '/controlPlatform' })
          }
        } else {
          // 直接注册
          const res = await teamListSelect()
          await switchTeam({ teamId: res.data[0].id })

          this.$message.success('注册成功!')
          localStorage.removeItem('account')
          localStorage.removeItem('password')
          this.$router.push({ path: '/controlPlatform' })
        }
      } catch (error) {
        // this.$message.error(error.message)
      }
    },
    // 获取验证码
    getCaptcha (e) {
      e.preventDefault()
      this.$refs.form.validateField(['account'],
        (err, values) => {
          if (!err) {
            this.state.smsSendBtn = true

            const interval = window.setInterval(() => {
              if (this.state.time-- <= 0) {
                this.state.time = 60
                this.state.smsSendBtn = false
                window.clearInterval(interval)
              }
            }, 1000)

            getSmsCaptcha({
              // operateType: 'register',
              type: 'feige_register',
              mobilePhone: this.form.account
            }).then(res => {
              if (res.code === 200) {
                this.$message.success('验证码已发送')
              }
            }).catch((err) => {
              // setTimeout(hide, 1)
              clearInterval(interval)
              this.state.time = 60
              this.state.smsSendBtn = false
              console.log(err)
            })
          }
        }
      )
    },
    clear () {
      this.form = this.$options.data().form
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
      this.isShowPassword = false
      this.isShowRePassword = false
    },
    close () {
      this.clear()
    },
    // 跳转登录
    gotoLogin () {
      // this.$router.push({
      //   name: 'register'
      // })
      this.$emit('showLoginMsg')
    },
    onClickRule () {
      this.$emit('showRulesMsg')
    }
  }
}
</script>

<style lang="scss">
.registerForm{
  width: 424px;
  height: 542px;
  background: url("~@/assets/images/bg2.png") no-repeat;
  background-size: contain;
  backdrop-filter: blur(5px);
  // z-index: 100;
  .header{
    position: relative;
    padding: 27px 0 0px 0;
  }
  .title{
    font-size: 24px;
    font-family: Source Han Sans SC;
    color: #FFFFFF;
    text-shadow: 0px 3px 9px rgba(93, 204, 255, 1.0), 0px 2px 17px rgba(77, 199, 255, 1.0);
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .close-btn{
    position: absolute;
    right: 6px;
    top: 6px;
    width: 47px;
    height: 47px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba($color: #4D9FC6, $alpha: 0.5);
    box-shadow: 1px 2px 9px 1px rgba(0, 0, 0, 0.1);
    border-radius: 0px 24px 1px 24px;
    line-height: 53px;
    cursor: pointer;
    svg {
      font-size: 24px;
      color: #49B8FF;
    }
  }
  .user-layout-login{
    padding: 0 50px;
    input::placeholder{
      color:#fff !important;
      opacity: 0.7 !important;
    }
    .el-checkbox .el-checkbox__input .el-checkbox__inner {
      border: 1px solid transparent;
    }
    .el-input .el-input__inner {
      height: 40px;
      border-color: #ddd;
      &:hover{
        border-color: $hover-color !important;
      }
    }
    .is-error .el-input__inner{
      border-color: #f54949;
    }
    .el-input__suffix{
      right: 10px;
      top: 2px;
    }
    .el-input__prefix{
      top: 3px;
      left: 10px;
    }
    .login-button{
      width: 100%;
      height: 42px;
      font-size: 18px !important;
      border-radius: 6px
    }
    .getCaptcha {
      width: 110px;
      height: 42px;
      background: rgba(255, 255, 255, 0.2) !important;
      border: unset !important;
      border-radius: 6px;
    }
    .show-password{
      color: #999;
      cursor: pointer;
      &:hover{
        color: $hover-color;
      }
    }
    svg{
      color: #aaa;
      font-size: 16px;
    }
    .text-button {
      display: flex;
      justify-content: flex-end;
      span{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #00A4F0;
        cursor: pointer;
      }
    }
    .user-rule-button{
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #00A4F0;
      cursor: pointer;
    }
  }
}
</style>
